import { makeStyles } from '@mui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: theme.spacing(2),
    minWidth: 400,
    maxWidth: 500,
    padding: theme.spacing(2)
  },
  iconContainer: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: theme.palette.warning.light,
    marginTop: theme.spacing(0.5)
  },
  icon: {
    color: theme.palette.warning.main
  },
  title: {
    fontWeight: 600,
    marginBottom: theme.spacing(1),
    color: theme.palette.text.primary
  },
  description: {
    color: theme.palette.text.secondary,
    lineHeight: 1.5
  },
  actions: {
    padding: theme.spacing(2, 3, 2, 3),
    justifyContent: 'flex-end'
  },
  signInButton: {
    minWidth: 120,
    padding: theme.spacing(1, 3)
  }
}))
